import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
//import Select from 'react-select';
//import { Redirect } from 'react-router-dom';

import uniqid from 'uniqid';

import Swal from 'sweetalert2'

import { confirmAlert } from 'react-confirm-alert';
import { getTokenInfo } from '../../../UseToken';

import Loader from '../../Loader/Loader';

import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app


import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	check_interface,
	repo_banner_link,
} from '../../../Utils';
import Hosts from '../../../Hosts';

import { language } from './Language';

export default function Regist(props) {

	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const [date_creation, set_date_creation] = useState('')
	const [date_modification, ] = useState('')
	const [date_publication, ] = useState('')
	const [date_avaiable, ] = useState('')

	const [lang, set_lang] = useState('pt');
	const [uid,] = useState(uniqid());

	const [mailOptions, setMailOptions] = useState({});

	const [, set_menus_avaiable] = useState([])

	//const [disabled, set_disabled] = useState(false)

	const [isloading, setLoading] = useState(true);
	//const [save_label, set_save_label] = useState('Salvar');
	//const [isRedirect, setRedirect] = useState(false);

	const [show_delete_button, set_show_delete_button] = useState(false);

	const [is_edit, set_is_edit] = useState(false)
	const [, setEditorLoaded] = useState(false);

	const [/*selectedFile*/, setSelectedFile] = useState(null);

	const [refresh, setRefresh] = useState(0);

	const [/*image_base64*/, set_image_base64] = useState([]);

	const [files_doc, set_files_doc] = useState([]);
	const [files_doc_name, set_files_doc_name] = useState([]);

	let compareDataWithInterface = (data, d_interface) => {

		data.id = check_interface(data.id, d_interface.id)

		data.info = check_interface(data.info, d_interface.info)
		data.info.type = check_interface(data.info.type, d_interface.info.type)

		data.info.name_01 = check_interface(data.info.name_01, d_interface.info.name_01)
		data.info.name_02 = check_interface(data.info.name_02, d_interface.info.name_02)
		data.info.name_03 = check_interface(data.info.name_03, d_interface.info.name_03)
		data.info.contact_01 = check_interface(data.info.contact_01, d_interface.info.contact_01)
		data.info.contact_02 = check_interface(data.info.contact_02, d_interface.info.contact_02)
		data.info.contact_03 = check_interface(data.info.contact_03, d_interface.info.contact_03)
		data.info.designation = check_interface(data.info.designation, d_interface.info.designation)

		data.info.option_02 = check_interface(data.info.option_02, d_interface.info.option_02)
		data.info.option_03 = check_interface(data.info.option_03, d_interface.info.option_03)

		data.info.description_01 = check_interface(data.info.description_01, d_interface.info.description_01)
		data.info.description_02 = check_interface(data.info.description_02, d_interface.info.description_02)
		data.info.description_03 = check_interface(data.info.description_03, d_interface.info.description_03)
		data.info.description_04 = check_interface(data.info.description_04, d_interface.info.description_04)
		data.info.description_05 = check_interface(data.info.description_05, d_interface.info.description_05)
		data.info.description_06 = check_interface(data.info.description_06, d_interface.info.description_06)
		data.info.description_07 = check_interface(data.info.description_07, d_interface.info.description_07)
		data.info.description_08 = check_interface(data.info.description_08, d_interface.info.description_08)
		data.info.description_09 = check_interface(data.info.description_09, d_interface.info.description_09)
		data.info.description_10 = check_interface(data.info.description_10, d_interface.info.description_10)

		data.info.parent = check_interface(data.info.parent, d_interface.info.parent)
		data.info.order = check_interface(data.info.order, d_interface.info.order)
		data.info.slug = check_interface(data.info.slug, d_interface.info.slug)
		data.info.status = check_interface(data.info.status, d_interface.info.status)
		data.info.notified = check_interface(data.info.notified, d_interface.info.notified)

	}


	const clean_data = async () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
	}

	const onChangeHandlerFile = (e) => {
        const { files } = e.target;

        let storedFiles = [];
        let filesArray = Array.prototype.slice.call(files);

        filesArray.forEach(async (v) => {
            // if((v.type.includes('/pdf')) && (v.size < 10485760)) {
            storedFiles.push(v);

            let aux2 = files_doc_name
            aux2.push({ name: v.name, size: v.size })
            set_files_doc_name(aux2)

            set_dados(dados.current,)
			console.log('FICHEIROS --------->', dados.current.info)
            setRefresh(refresh + 1)
            // }
            // else {
            // 	alert(language[lang].upload_file_error + v.name);
            // }
        });

        let files_aux = files_doc
        files_aux.push({ files: storedFiles })
        set_files_doc(files_aux)

    }

	const removeArticleFile = file => () => {
		files_doc.forEach((v) => {
            v.files.forEach((v2, k2) => {
                if(v2.name === file.name)
                    v.files.splice(k2, 1)
            })
        })
        set_files_doc(files_doc)

        console.log('FILES DOC 2', files_doc)

		//const newFiles = [...myFiles]
		const newFiles = [...files_doc_name]
		newFiles.splice(newFiles.indexOf(file), 1)
		set_files_doc_name(newFiles)
		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))
		//setMyFiles(newFiles)
	}
	const removeArticleFile_2 = file => () => {

		dados.current.info.files.forEach((v, k) => {

				console.log('VVVVV', v)

                if(v.name === file.name)
					dados.current.info.files.splice(k, 1)
        })
        set_dados(dados.current.info.files)

        console.log('FILES DOC 2', files_doc)


	}

	

	useEffect(() => {

		const order_menu = (parent, array, array2) => {
			let array_aux = array.filter(v => v.info.parent === parent)
			array_aux.forEach(v => {
				array2.push(v)
				order_menu(v.id, array, array2)
			})
		}

		const get_menus_avaiable = async () => {
			return await reqGET(`${api_crud_base}/web/content/type/${getTokenInfo().companycode}/content`)
				.then(res => {
	
					let array_aux = []
					order_menu('0', res.data, array_aux)
					set_menus_avaiable(array_aux);
	
				})
				.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
		}

		const fetch_id_info = async (id_serch) => {
			return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
				.then(res => {
	
					compareDataWithInterface(res.data[0], dados.current)
	
					set_dados(dados.current = res.data[0]);
					if (res.data[0].info['media'] !== undefined)
						setSelectedFile(res.data[0].info.media)
	
					let aux = []
	
					//setSelectedFiles(aux)
	
					let aux_doc = []
					let i = 0
					aux.forEach((el, k) => {
						el.forEach((el_2, k_2) => {
							el_2.doc.forEach((el_3) => {
								if (aux_doc[k] === undefined)
									aux_doc[k] = []
								if (aux_doc[k][k_2] === undefined)
									aux_doc[k][k_2] = []
	
								aux_doc[k][k_2].push({ id: ++i, id_doc: el_3.id, title: el_3.name, link: el_3.link, visible: el_3.visible })
							})
						})
					})
					//console.log(res.data[0])
				})
				.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
		}

		clean_data();

		set_lang(localStorage.getItem('lang'))

		get_menus_avaiable();

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				set_is_edit(true)
				set_show_delete_button(true)

				set_image_base64([])
				set_files_doc_name([])

				fetch_id_info(props.location.state.item['id'])
					.then(() => {

						if (dados.current.info.date !== undefined && dados.current.info.date !== '') {
							let date_creation = new Date(dados.current.info.date);
							set_date_creation(date_creation.getDate().toString().padStart(2, '0') + '/' + (date_creation.getMonth() + 1).toString().padStart(2, '0') + '/' + date_creation.getFullYear())
						}

						let emailTo = '';

						/*let name = ''

						name = dados.current.info.name*/

						emailTo = dados.current.info.email;

						//set_dados(dados.current.info.status = true)


						/* dados3.info.reviewer_access = dados.current.info.reviewer_access;*/

						setMailOptions({
							from: Hosts.contactFrom,
							// vários emails separados por virgulas
							to: emailTo,
							//to: 'suporte@assec.pt',

							//cc-> opcional
							//cc: Hosts.contactFrom,
							subject: Hosts.webSiteTitle + ' - ' + language[lang].contest,
							//text: 'Teste de EMAIL ', -> opcional
							html:

								'<div style="width:100% !important;margin-top:0;margin-bottom:0;margin-right:0;margin-left:0;padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;color:#425968;background-color:#F7F7F7;background-image:none;background-repeat:repeat;background-position:top left;background-attachment:scroll;font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:16px;">' +
								'<table border="0" align="center" cellpadding="0" cellspacing="0" style="margin-top:0;margin-bottom:0;padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;border-collapse:collapse;">' +
								'<tr style="border-collapse: collapse;">' +
								'<td style="border-collapse: collapse;">' +
								'<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; background-color:#ffffff;border:1px solid transparent;border-collapse:collapse;">' +
								'<tr style="border-collapse: collapse;">' +
								'<td align="left" class="logo" style="padding:0; border-collapse:collapse;">' +
								'<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank">' +
								'<img style="width: 600px; height: 90px;" width="600" height="90" src="' + repo_banner_link("banner-email.jpg") + '"/>' +
								'</a>' +
								'</td>' +
								'</tr>' +
								'</table>' +
								'<table width="540" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 540px; height: 90px; padding: 15px 30px; background-color:#ffffff;border:1px solid transparent;border-collapse:collapse;">' +
								'<tr style="border-collapse: collapse;">' +
								'<td align="left" class style="padding:0 0 10px; border-collapse:collapse;">' +
								'<div style="width:540px; margin: 0 auto; padding-left: 30px; padding-right: 30px;">' +
								'<h4>' + language[lang].app_form_title + ':</h4>' +
								'<span>' + language[lang].hello + ',</span>' +
								'<br/>' +
								'<span>' + language[lang].email_text + '<b>' + language[lang][dados.current.info.status] + '</b>.</span>' +
								'<br/>' +
								'<span>' + language[lang].email_text_02 + '</span>' +
								'<br/>' +
								'<span>' + language[lang].email_text_03 + '</span>' +
								'<br/>' +
								'<br/>' +
								'<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.WEB_SITE_URI + '" target="_blank">' + Hosts.webSiteTitle + '</a>' +
								'<br/>' +
								'</div>' +
								'</td>' +
								'</tr>' +
								'</table>' +
								'<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; background-color:' + Hosts.FOOTER_EMAIL_COLOR + '; padding: 10px; border:1px solid transparent;border-collapse:collapse;">' +
								'<tr style="border-collapse: collapse;">' +
								'<td align="left" style="padding:10px 0px; border-collapse:collapse;">' +
								'<div style="margin: 0 auto; width:600px;">' +
								'<div style="text-align: center; font-size: small; color: #FFFFFF;">' +
								'<span style="text-transform: uppercase;">' + Hosts.webSiteTitle + '</span>' +
								'<br/>' +
								'<span>' + Hosts.webSiteAdress + '</span>' +
								'<br/>' +
								'<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank" style="text-decoration:none;"> ' +
								'<span style="color: #FFFFFF;" >' + Hosts.EMAIL_WEB_SITE_URL + '</span>' +
								'</a>' +
								'</div>' +
								'</div>' +
								'</td>' +
								'</tr>' +
								'</table>' +
								'</td>' +
								'</tr>' +
								'</table>' +
								'</div>',

						});


						setLoading(false)
						setEditorLoaded(true);
					})
				return
			}

			// VAI REGISTAR
			if (test === undefined) {
				setLoading(false);
				return
			}
		} catch {
			// VAI REGISTAR

			//setRedirect(false);
			setLoading(false)

			clean_data()
				.then(() => {
					setEditorLoaded(true);
				})

			return
		}

		//props.history.push(endpoints.list)
		return () => {
			clean_data()
		}


	}, [props, lang])

	const handleSubmit = async e => {
		e.preventDefault();

		var today_submit = new Date()

		if (is_edit === true) {
			//alert('Atualizar PUT')

			if (dados.current.info.uniqid !== undefined)
				delete dados.current.info.uniqid;

			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
				.then((result) => {
					if (result.isConfirmed) {

						files_doc.forEach(async (el_doc) => {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, dados.current.id)
							}
						})
						set_files_doc([])
						set_files_doc_name([])

						//dados.current.info.date.modified.push(today_submit)
						reqPUT(api_crud_route, dados.current)
							.then(() => {
								//props.history.push(endpoints.list) 

								Swal.fire(language[lang].edit_success, '', 'info')
							})
							.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
					}
				})

		} else {
			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
				.then((result) => {
					if (result.isConfirmed) {
						dados.current.info['uniqid'] = uid
						dados.current.info.date = today_submit

						reqPOST(api_crud_route, dados.current)
							.then(() => {

								reqGET(`${api_crud_base}/web/content/uniqid/${getTokenInfo().companycode}/${uid}`)
									.then(res => {
										console.log(res.data)
										dados.current.id = res.data[0].id

										files_doc.forEach(async (el_doc) => {
											if (el_doc !== null) {
												await uploadFilesDoc(el_doc.files, res.data[0].id)
											}
										})
										set_files_doc([])
										set_files_doc_name([])

										set_is_edit(true)
										set_show_delete_button(true)
									})
									.catch(() => 404)

								Swal.fire(language[lang].insert_success, '', 'info')

								//props.history.push(endpoints.list) 
							})
							.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
					}
				})
		}
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					reqDELETE(api_crud_route + '/', { id: dados.current.id })
						.then(() => {

							props.history.push(endpoints.list);

						})
						.catch(() => Swal.fire(language[lang].delete_error, '', 'info'))
				}
			})
	};

	const handle_change_info = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name] = value)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const send_notification = (id) => {
		if (dados.current.info.status !== 'under_review') {

			/*console.log('«««««««««««««««««««««««')
			console.log('Dados Current:' + JSON.stringify(dados))*/

			//console.log('EMAIL:' + v.email)
			//console.log('CONTACT EMAIL:' + v.contactemail)


			confirmAlert({
				title: language[lang].notify,
				message: language[lang].notify_message,
				buttons: [
					{
						label: language[lang].yes,
						onClick: () => {

							//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
							//console.log('Dados Current:' + JSON.stringify(dados3)) 

							//let reviewer = dados.current.info.reviewer_access.filter(v => v.reviewers.id === id);
							//console.log('Revisor a guardar e notificar: ', reviewer);


							set_dados(dados.current.info.status = true)

							/* dados3.info.reviewer_access = dados.current.info.reviewer_access;*/

							reqPOST(`${Hosts.SIMCore_API_MAIL}`, { data: mailOptions })
								.then(() => {
									console.log('Notificações enviadas com sucesso')
									document.getElementById('form_modal').reset();

									//document.getElementById('modal_form').modal('hide');
									//clean_data()
								})
								.catch((error) => console.log(error)/*alert('Problema ao enviar notificações!')*/)

						}
					},
					{
						label: language[lang].no,
						onClick: () => { return }
					}
				]
			})
			//console.log(res)

		}

		else {
			alert(language[lang].notify_appreciation_error_message)
		}


	};

	/*const uploadFilesImage = (files, order, type, langid, lang) => {

		let aux = []
		files.forEach(async (element) => {
			if (element.type.includes('image/')) {
				aux.push(element)

				await uploadFile(element, order, type, langid, lang)
					.then(() => {
						//console.log('success')
					})
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		})
	}*/

	const uploadFilesDoc = (files, id) => {
		let aux = []
        files.forEach((element) => {
            // if(element.type === "application/pdf") {
            aux.push(element)

            uploadFile(element, id)
                .then(() => {
                    //console.log('success')
                })
            // }
            // else {
            // 	Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
            // }
        })
	}

	const uploadFile = async (file, id) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', id)
		formData.append('file_name', file.name)
		formData.append('type', 'contest')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('uniqid', dados.current.info.uniqid)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/app/');

		return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
			.then((res) => {
				console.log('RES DATA', res.data)

                dados.current.info.files.push({
                    link: res.data.path + '/' + res.data.name,
                    name: res.data.name,
                })

                console.log('«««««««««««««««««««««««')
		        console.log('Dados Current:' + JSON.stringify(dados))

                reqPUT(`${Hosts.SIMCore_API}/contest/form`, dados.current)
                    .then(() => {
                        
                        //props.history.push(endpoints.list) 
                    })
                    .catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

                return true
			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}


	return isloading ?

		<Loader />

		:

		<main>
			<form id="form" onSubmit={handleSubmit}>
				<input type="hidden" name="id" value={dados.current.id} />

				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].contests}</h2>
					<p>{language[lang].contests} / {dados.current.id !== '' ? language[lang].contest_edit : language[lang].contest_new}</p>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
							<div className="col-md-8 mb-5 mb-xl-10">

								<div className="tab-content" id="tabContent">
									<div className="row mb-2">
										<label className="col-form-label fw-bold fs-6">{language[lang].app_form_title_01}*</label>
										<div className="col-12 col-sm-8">
											<label className="col-form-label fw-bold fs-6">{language[lang].name}*</label>
											<input type="text" name="name_01"
												value={dados.current.info.name_01}
												className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
												placeholder=""
												onChange={handle_change_info}
												required
											/>
										</div>
										<div className="col-12 col-sm-4">
											<label className="col-form-label fw-bold fs-6">{language[lang].contact}*</label>
											<input type="text" name="contact_01"
												value={dados.current.info.contact_01}
												className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
												placeholder=""
												onChange={handle_change_info}
												required
											/>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-12 col-sm-8">
											<label className="col-form-label fw-bold fs-6">{language[lang].name}</label>
											<input type="text" name="name_02"
												value={dados.current.info.name_02}
												className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
												placeholder=""
												onChange={handle_change_info}
											/>
										</div>
										<div className="col-12 col-sm-4">
											<label className="col-form-label fw-bold fs-6">{language[lang].contact}</label>
											<input type="text" name="contact_02"
												value={dados.current.info.contact_02}
												className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
												placeholder=""
												onChange={handle_change_info}
											/>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-12 col-sm-8">
											<label className="col-form-label fw-bold fs-6">{language[lang].name}</label>
											<input type="text" name="name_03"
												value={dados.current.info.name_03}
												className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
												placeholder=""
												onChange={handle_change_info}
											/>
										</div>
										<div className="col-12 col-sm-4">
											<label className="col-form-label fw-bold fs-6">{language[lang].contact}</label>
											<input type="text" name="contact_03"
												value={dados.current.info.contact_03}
												className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
												placeholder=""
												onChange={handle_change_info}
											/>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-12">
											<label className="col-form-label fw-bold fs-6">{language[lang].email_02}*</label>
											<input type="text" name="email"
												value={dados.current.info.email}
												className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
												placeholder=""
												onChange={handle_change_info}
												required
											/>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-12">
											<label className="col-form-label fw-bold fs-6">{language[lang].designation}*</label>
											<textarea type="text" name="designation"
												value={dados.current.info.designation}
												className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
												placeholder=""
												onChange={handle_change_info}
												required
											/>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-12">
											<div className="row">
												<label className="col-form-label fw-bold fs-6">{language[lang].app_form_title_02}*</label>
												<div className="col-3">
													<input
														id="option_02"
														type="radio"
														name="option_02"
														value="app_form_option_02_01"
														defaultChecked={dados.current.info.option_02 === 'app_form_option_02_01' ? true : false}
														onChange={handle_change_info}
													/>
													<span className="checkmark"></span>
													<label className="assec-pl-5" htmlFor="option_02">{language[lang].app_form_option_02_01}</label>
												</div>
												<div className="col-3">
													<input
														id="option_02"
														type="radio"
														name="option_02"
														value="app_form_option_02_02"
														defaultChecked={dados.current.info.option_02 === 'app_form_option_02_02' ? true : false}
														onChange={handle_change_info}
													/>
													<span className="checkmark"></span>
													<label className="assec-pl-5" htmlFor="option_02">{language[lang].app_form_option_02_02}</label>
												</div>
												<div className="col-3">
													<input
														id="option_02"
														type="radio"
														name="option_02"
														value="app_form_option_02_03"
														defaultChecked={dados.current.info.option_02 === 'app_form_option_02_03' ? true : false}
														onChange={handle_change_info}
													/>
													<span className="checkmark"></span>
													<label className="assec-pl-5" htmlFor="option_02">{language[lang].app_form_option_02_03}</label>
												</div>
												<div className="col-3">
													<input
														id="option_02"
														type="radio"
														name="option_02"
														value="app_form_option_02_04"
														defaultChecked={dados.current.info.option_02 === 'app_form_option_02_04' ? true : false}
														onChange={handle_change_info}
													/>
													<span className="checkmark"></span>
													<label className="assec-pl-5" htmlFor="option_02">{language[lang].app_form_option_02_04}</label>
												</div>
												<div className="col-3">
													<input
														id="option_02"
														type="radio"
														name="option_02"
														value="app_form_option_02_05"
														defaultChecked={dados.current.info.option_02 === 'app_form_option_02_05' ? true : false}
														onChange={handle_change_info}
													/>
													<span className="checkmark"></span>
													<label className="assec-pl-5" htmlFor="option_02">{language[lang].app_form_option_02_05}</label>
												</div>
												<div className="col-3">
													<input
														id="option_02"
														type="radio"
														name="option_02"
														value="app_form_option_02_06"
														defaultChecked={dados.current.info.option_02 === 'app_form_option_02_06' ? true : false}
														onChange={handle_change_info}
													/>
													<span className="checkmark"></span>
													<label className="assec-pl-5" htmlFor="option_02">{language[lang].app_form_option_02_06}</label>
												</div>
												<div className="col-3">
													<input
														id="option_02"
														type="radio"
														name="option_02"
														value="app_form_option_02_07"
														defaultChecked={dados.current.info.option_02 === 'app_form_option_02_07' ? true : false}
														onChange={handle_change_info}
													/>
													<span className="checkmark"></span>
													<label className="assec-pl-5" htmlFor="option_02">{language[lang].app_form_option_02_07}</label>
												</div>
												<div className="col-3">
													<input
														id="option_02"
														type="radio"
														name="option_02"
														value="app_form_option_02_08"
														defaultChecked={dados.current.info.option_02 === 'app_form_option_02_08' ? true : false}
														onChange={handle_change_info}
													/>
													<span className="checkmark"></span>
													<label className="assec-pl-5" htmlFor="option_02">{language[lang].app_form_option_02_08}</label>
												</div>
												<div className="col-3">
													<input
														id="option_02"
														type="radio"
														name="option_02"
														value="app_form_option_02_09"
														defaultChecked={dados.current.info.option_02 === 'app_form_option_02_09' ? true : false}
														onChange={handle_change_info}
													/>
													<span className="checkmark"></span>
													<label className="assec-pl-5" htmlFor="option_02">{language[lang].app_form_option_02_09}</label>
												</div>
												<div className="col-3">
													<input
														id="option_02"
														type="radio"
														name="option_02"
														value="app_form_option_02_10"
														defaultChecked={dados.current.info.option_02 === 'app_form_option_02_10' ? true : false}
														onChange={handle_change_info}
													/>
													<span className="checkmark"></span>
													<label className="assec-pl-5" htmlFor="option_02">{language[lang].app_form_option_02_10}</label>
												</div>
											</div>
										</div>
									</div>

									<div className="row mb-2">
										<div className="col-12">
											<div className="row">
												<label className="col-form-label fw-bold fs-6">{language[lang].app_form_title_03}*</label>
												<div className="col-3">
													<input
														id="option_03"
														type="radio"
														name="option_03"
														value="app_form_option_03_01"
														defaultChecked={dados.current.info.option_03 === 'app_form_option_03_01' ? true : false}
														onChange={handle_change_info}
													/>
													<span className="checkmark"></span>
													<label className="assec-pl-5" htmlFor="option_03">{language[lang].app_form_option_03_01}</label>
												</div>
												<div className="col-3">
													<input
														id="option_03"
														type="radio"
														name="option_03"
														value="app_form_option_03_02"
														defaultChecked={dados.current.info.option_03 === 'app_form_option_03_02' ? true : false}
														onChange={handle_change_info}
													/>
													<span className="checkmark"></span>
													<label className="assec-pl-5" htmlFor="option_03">{language[lang].app_form_option_03_02}</label>
												</div>
												<div className="col-3">
													<input
														id="option_03"
														type="radio"
														name="option_03"
														value="app_form_option_03_03"
														defaultChecked={dados.current.info.option_03 === 'app_form_option_03_03' ? true : false}
														onChange={handle_change_info}
													/>
													<span className="checkmark"></span>
													<label className="assec-pl-5" htmlFor="option_03">{language[lang].app_form_option_03_03}</label>
												</div>
												<div className="col-3">
													<input
														id="option_03"
														type="radio"
														name="option_03"
														value="app_form_option_03_04"
														defaultChecked={dados.current.info.option_03 === 'app_form_option_03_04' ? true : false}
														onChange={handle_change_info}
													/>
													<span className="checkmark"></span>
													<label className="assec-pl-5" htmlFor="option_03">{language[lang].app_form_option_03_04}</label>
												</div>
											</div>
										</div>
									</div>

									<div className="row mb-2">
										<div className="col-12">
											<label className="col-form-label fw-bold fs-6">{language[lang].app_form_title_04}*</label>
											<textarea type="text" name="description_01"
												value={dados.current.info.description_01}
												className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
												placeholder=""
												onChange={handle_change_info}
												required
											/>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-12">
											<label className="col-form-label fw-bold fs-6">{language[lang].app_form_title_05}*</label>
											<textarea type="text" name="description_02"
												value={dados.current.info.description_02}
												className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
												placeholder=""
												onChange={handle_change_info}
												required
											/>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-12">
											<label className="col-form-label fw-bold fs-6">{language[lang].app_form_title_06}*</label>
											<textarea type="text" name="description_03"
												value={dados.current.info.description_03}
												className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
												placeholder=""
												onChange={handle_change_info}
												required
											/>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-12">
											<label className="col-form-label fw-bold fs-6">{language[lang].app_form_title_07}*</label>
											<textarea type="text" name="description_04"
												value={dados.current.info.description_04}
												className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
												placeholder=""
												onChange={handle_change_info}
												required
											/>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-12">
											<label className="col-form-label fw-bold fs-6">{language[lang].app_form_title_08}*</label>
											<textarea type="text" name="description_05"
												value={dados.current.info.description_05}
												className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
												placeholder=""
												onChange={handle_change_info}
												required
											/>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-12">
											<label className="col-form-label fw-bold fs-6">{language[lang].app_form_title_09}*</label>
											<textarea type="text" name="description_06"
												value={dados.current.info.description_06}
												className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
												placeholder=""
												onChange={handle_change_info}
												required
											/>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-12">
											<label className="col-form-label fw-bold fs-6">{language[lang].app_form_title_10}*</label>
											<textarea type="text" name="description_07"
												value={dados.current.info.description_07}
												className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
												placeholder=""
												onChange={handle_change_info}
												required
											/>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-12">
											<label className="col-form-label fw-bold fs-6">{language[lang].app_form_title_11}*</label>
											<textarea type="text" name="description_08"
												value={dados.current.info.description_08}
												className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
												placeholder=""
												onChange={handle_change_info}
												required
											/>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-12">
											<label className="col-form-label fw-bold fs-6">{language[lang].app_form_title_12}*</label>
											<textarea type="text" name="description_09"
												value={dados.current.info.description_09}
												className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
												placeholder=""
												onChange={handle_change_info}
												required
											/>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-12">
											<label className="col-form-label fw-bold fs-6">{language[lang].app_form_title_13}*</label>
											<textarea type="text" name="description_10"
												value={dados.current.info.description_10}
												className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
												placeholder=""
												onChange={handle_change_info}
												required
											/>
										</div>
									</div>
									<div className="row">
										<div className="col-12">
											<label className="control-label">{language[lang].files}</label>
											<span className="custom-file-label"></span>
											<input
												name="docs"
												className="custom-file-input"
												type="file"
												accept="image/png,image/gif,image/jpeg,application/pdf"
												onChange={onChangeHandlerFile}
												//disabled={(dados.current.info.vat === '' || dados.current.info.course.id === '')}
												multiple
											/>

										</div>
									</div>
									<div className="">
										{dados.current.info.files.map(file => (
											<li key={file.name}>        
												{file.name} - {file.size} bytes{" "}
												
												<button type="button" className="upload-button" title={language[lang].remove_file} alt={language[lang].remove_file} onClick={removeArticleFile_2(file)}>X</button>
												{/* <br></br>
												<button className="upload-button" onClick={onFileUpload}>Upload!</button> */}
											</li>
										))}
										{files_doc_name.map(file => (
											<li key={file.name}>        
												{file.name} - {file.size} bytes{" "}
												
												<button type="button" className="upload-button" title={language[lang].remove_file} alt={language[lang].remove_file} onClick={removeArticleFile(file)}>X</button>
												{/* <br></br>
												<button className="upload-button" onClick={onFileUpload}>Upload!</button> */}
											</li>
										))}
									</div>

								</div>
							</div>

							<div className="col-md-4 mb-5 mb-xl-10">
								<div className="card mb-5">
									<div className="card-header border-0 cursor-pointer" role="button" data-bs-toggle="collapse" data-bs-target="#div_configuracao" aria-expanded="true" aria-controls="div_configuracao">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].page_config}</h3>
										</div>
									</div>
									<div id="div_configuracao" className="collapse show">
										<div className="card-body border-top p-4">

											<div className="">
												<input
													id="radio_0"
													type="radio"
													name="status"
													value="rejected"
													defaultChecked={dados.current.info.status === 'rejected' ? true : false}
													onChange={handle_change_info}
												/>
												<span className="checkmark"></span>
												<label className="assec-pl-5" htmlFor="radio_0">{language[lang].rejected}</label>
											</div>

											<div className="">
												<input
													id="radio_1"
													type="radio"
													name="status"
													value="accepted"
													defaultChecked={dados.current.info.status === 'accepted' ? true : false}
													onChange={handle_change_info}
												/>
												<span className="checkmark"></span>
												<label className="assec-pl-5" htmlFor="radio_1">{language[lang].accepted}</label>
											</div>

											<button disabled={dados.current.info.status === 'under_review'} className={(dados.current.info.status === 'under_review' ? 'button-yellow' : (dados.current.info.notified === true ? 'button-green' : 'button-yellow')) + " assec-ml-15 float-right"} type="button" onClick={() => send_notification(dados.current.id)}>
												{(dados.current.info.notified === true ? language[lang].notified : language[lang].notify)}
											</button>

											<div className="mb-3">
												<label className="col-form-label fw-bold fs-6">{language[lang].dates}</label>
												<p>
													<strong>{language[lang].date_creation}:</strong> {date_creation !== '' ? date_creation : ''}<br />
													<strong>{language[lang].date_publication}:</strong> {date_publication !== '' ? date_publication : ''}<br />
													<strong>{language[lang].date_avaiable}:</strong> {date_avaiable !== '' ? date_avaiable : ''}<br />
													<strong>{language[lang].date_last_update}:</strong> {date_modification !== '' ? date_modification : ''}
												</p>
											</div>
										</div>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
										<img alt='' src={'./img/cancelar.svg'} />
										<span>{language[lang].cancel}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<img alt='' src={'./img/eliminar_b.svg'} />
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<img alt='' src={'./img/save.svg'} />
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</form>
		</main>

}
